import { NgModule, ModuleWithProviders } from '@angular/core';
import {
  MdlDataGridComponent
} from './mdl-data-grid.component';
import { MdlCheckboxModule } from '../checkbox/mdl-checkbox.component';
import { MdlRippleModule } from '../common/mdl-ripple.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export * from './mdl-data-grid.component';

const MDL_GRID_DIRECTIVES = [
  MdlDataGridComponent
];

@NgModule({
  imports: [MdlCheckboxModule, MdlRippleModule, CommonModule, FormsModule],
  exports: MDL_GRID_DIRECTIVES,
  declarations: MDL_GRID_DIRECTIVES,
})
export class MdlDataGridModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: MdlDataGridModule,
      providers: []
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-grid/index.ts